import { createRouter, createWebHistory } from 'vue-router'
import RoundDetail from '../views/RoundDetailVx.vue'
import FeedBrowser from '../views/RssFeedBrowserVx.vue'
import NoAccess from '../views/NoAccess.vue'
import Error from '../views/Error.vue'
import TopicTypeDetail from '../views/TopicTypeDetailVx.vue'
import ExpertTypeDetail from '../views/ExpertTypeDetailVx.vue'
import TermDetail from '../views/TermDetailVx.vue'
import ModulRegionDetail from '../views/ModulRegionDetailVx.vue'
import EventLogDetail from '../views/EventLogDetailVx.vue'
import NotificationAdmin from '../views/NotificationAdminVx.vue'
import NotificationEventDetail from '../views/NotificationEventDetailVx.vue'
import RssFeedDetail from '../views/RssFeedDetailVx.vue'
import AppObjectDetail from '../views/AppObjectDetailVx.vue'
import AffiliationDetail from '../views/AffiliationDetailVx.vue'
import TopicEntry from '../views/TopicEntry.vue'
import TopicComment from '../views/TopicComment.vue'
import GroupDetail from '../views/GroupDetailVx.vue'
import SuchfeldDetail from '../views/SuchfeldDetailVx.vue'
import TopicLinkTypeList from '../views/TopicLinkTypeList.vue'
import TopicLinkTypeStatusList from '../views/TopicLinkTypeStatusList.vue'
import TopicLinkTypeStatusDetail from '../views/TopicLinkTypeStatusDetail.vue'
import MfgSelection from '../views/MfgSelection.vue'
import PolicyCards from '../views/PolicyCards.vue'
import StakeholderCards from '../views/StakeholderCards.vue'
import StakeholderGroupsCards from '../views/StakeholderGroupsCards.vue' 
import ProjectOutputCards from '../views/ProjectOutputCards.vue'
import SatelliteMissionsCards from '../views/SatelliteMissionsCards.vue'
import StakeholderRequirmentsCards from '../views/StakeholderRequirmentsCards.vue'
import ProjectsCards from '../views/ProjectsCards.vue'
import RssFeedBrowserIntro from '../views/RssFeedBrowserIntroVx.vue'
import TopicOverview from '../views/TopicOverview.vue'
import ModulTypeDetail from '../views/ModulTypeDetailVx.vue'
import ModulTypeAttributeDetail from '../views/ModulTypeAttributeDetailVx.vue'
import StatusDetail from '../views/StatusDetailVx.vue'
import TopicMemberStatesDetail from '../views/TopicMemberStateVx.vue'
import PresentationGroupDetail from '../views/PresentationGroupDetailVx.vue'
import CreateNewTopic from '../views/CreateNewTopic.vue'
import ActivateNewAccount from '../views/ActivateNewAccountVx.vue'
import WorkflowDetail from '../views/WorkflowDetailVx.vue'
import HelpEntryDetail from '../views/HelpEntryDetailVx.vue'
import DashboardExpert from '../views/DashboardExpertVx.vue'
import DashboardAdminVx from '../views/DashboardAdminVx.vue'
import DashboardVotingVx from '../views/DashboardVotingVx.vue'
import LandingPageInternal from '../views/LandingPageInternal.vue'
import LandingPage from '../views/LandingPage.vue'
import ApplicationStatus from '../views/ApplicationStatus.vue'
import MentorApplicationStatus from '../views/MentorApplicationStatus.vue'
import ProfileStatusVx from '../views/ProfileStatusVx.vue'
import MentorProfileStatusVx from '../views/MentorProfileStatusVx.vue'
import CommunityVx from '../views/CommunityVx.vue'
import Faq from '../views/Faq.vue'
import LoginPage from '../views/LoginPage.vue'
import RegisterAsParticipant from '../views/RegisterAsParticipant.vue'
import RegisterAsMentor from '../views/RegisterAsMentor.vue'
import VotingOverview from '../views/VotingOverview.vue'
import TopicCardView from '../views/TopicCardView.vue'
import TopicCardClusterView from '../views/ClusterCardView.vue'
import TopicCardRadar from '../views/Systematisierung.vue'
import TagDetail from '../views/TagDetailVx.vue'
import ListOverview from '../views/ListOverview.vue'
import TopicNetwork from '../views/TopicNetwork.vue'
import TopicNetworkWidget from '../views/TopicNetworkWidget.vue'
import ResetAccount from '../views/ResetAccount.vue'
import AcceptTerms from '../views/AcceptTerms.vue'
import IdeaEvaluationOverview from '../views/IdeaEvaluationOverviewVx.vue'
import Index from '../views/Index.vue'
import NotificationDetail from '../views/NotificationDetailVx.vue'
import ThemeSwitcher from '../views/ThemeSwitcher.vue'
import PersonDetail from '../views/PersonDetailVx.vue'
import TopicMemberRoleDetail from '../views/TopicMemberRoleDetailVx.vue'
import RatingTypeGroupDetail from '../views/RatingTypeGroupDetail.vue'
import EmailConfirmation from '../views/EmailConfirmation.vue'
import ActivateAccount from '../views/ActivateAccount.vue'
import ResetPassword from '../views/ResetPassword.vue'
import EmailSettings from '../views/EmailSettings.vue'
import CountryStats from '../views/widgets/statistics/countryStatsMap.vue'
import ProjectLocalisationMap from '../views/ProjectLocalisationMap.vue'
import RecentChangedTopics from '../views/widgets/RecentChangedTopics.vue'
import EarlyAdopterLocalisationMap from '../views/EarlyAdopterLocalisationMap.vue'
// import TokenUsageDashboard from '../views/TokenUsageDashboard.vue'  // hidden placeholder, route below disabled
import DataImport from '../views/DataImportVx.vue'
import ImportHistoryVx from '../views/ImportHistoryVx.vue'
import ImportHistoryDetailVx from '../views/ImportHistoryDetailVx.vue'

var path = window.ApplicationPath;
if (path.endsWith("/")) {
    path = path.substring(0, path.length - 1);
}

const routes = [
    {
        path: path + '/Index.aspx/:menuId?',
        alias: path + '/Index/:menuId?',
        name: 'Index',
        component: Index,
        props: true,
    },
    {
        path: path + '/Admin/StatusDetailVx.aspx/:statusId?/:newWorId?',
        alias: path + '/Admin/StatusDetailVx.aspx/:statusId?/:newWorId?',
        name: 'StatusDetail',
        component: StatusDetail,
        props: true,
    },
    {
        path: path + '/Admin/TopicLinkTypeList.aspx/:statusId?/:newWorId?',
        alias: path + '/Admin/TopicLinkTypeList.aspx/:statusId?/:newWorId?',
        name: 'TopicLinkTypeList',
        component: TopicLinkTypeList,
        props: true,
    },
    {
        path: path + '/Analyze/CountryStats.aspx',
        alias: path + '/Analyze/CountryStats.aspx',
        name: 'CountryStats',
        component: CountryStats,
        props: true,
    },
    {
        path: path + '/Views/ProjectLocalisationMap.aspx',
        name: 'ProjectLocalisationMap',
        component: ProjectLocalisationMap,
        props: true,
    },
    {
        path: path + '/Views/EarlyAdopterLocalisationMap.aspx',
        name: 'EarlyAdopterLocalisationMap',
        component: EarlyAdopterLocalisationMap,
        props: true,
    },
    {
        path: path + '/Admin/TopicLinkTypeStatusListVx.aspx',
        name: 'TopicLinkTypeStatusList',
        component: TopicLinkTypeStatusList
    },
    {
        path: path + '/Admin/TopicLinkTypeStatusDetailVx.aspx',
        name: 'TopicLinkTypeStatusDetail',
        component: TopicLinkTypeStatusDetail,
        props: (route) => {
            var tlsId = Number.parseInt(route.query.tlsId, 10);
            if (Number.isNaN(tlsId)) {
                tlsId = 0;
            }
            return { tlsId };
        }
    },
    {
        path: path + '/Admin/TopicMemberStateVx.aspx/:tmsId?/:newTtyId?',
        alias: path + '/Admin/TopicMemberStateVx.aspx/:tmsId?/:newTtyId?',
        name: 'TopicMemberStatesDetail',
        component: TopicMemberStatesDetail,
        props: true,
    },
    {
        path: path + '/Admin/AppObjectDetailVx.aspx/:objId?',
        name: 'AppObjectDetail',
        component: AppObjectDetail,
        props: true,
    },
    {
        path: path + '/Admin/AffiliationDetailVx.aspx',
        name: 'AffiliationDetail',
        component: AffiliationDetail
    },
    {
        path: path + '/Public/AcceptTerms.aspx',
        name: 'AcceptTerms',
        component: AcceptTerms
    },
    {
        path: path + '/Admin/GroupDetailVx.aspx/:grpId?',
        name: 'GroupDetailVx',
        component: GroupDetail,
        props: true,
    },
    {
        path: path + '/Admin/HelpEntryDetailVx.aspx',
        name: 'HelpEntryDetail',
        component: HelpEntryDetail
    },
    {
        path: path + '/Views/IdeaEvaluationOverviewVx.aspx',
        alias: path + '/Views/IdeaEvaluationOverviewVx.aspx',
        name: 'IdeaEvaluationOverview',
        component: IdeaEvaluationOverview,
        props: true,
    },
    {
        path: path + '/Views/DashboardExpertVx.aspx',
        name: 'DashboardExpert',
        component: DashboardExpert
    },
    {
        path: path + '/LandingPage.aspx',
        name: 'LandingPage',
        component: LandingPage
    },
    {
        path: path + '/Public/NoAccess.aspx',
        name: 'NoAccess',
        component: NoAccess
    },
    {
        path: path + '/Error.aspx',
        name: 'Error',
        component: Error,
        props: (route) => {
            var errorMessage = "";
            try {
                errorMessage = atob(route.query.Error);
            }
            catch {
                errorMessage = "An unknown error occured.";
            }
            return { errorMessage }
        }
    },
    {
        path: path + '/Login.aspx',
        name: 'LoginPage',
        component: LoginPage
    },
    {
        path: path + '/Public/RegisterAsParticipant.aspx',
        name: 'RegisterAsParticipant',
        component: RegisterAsParticipant
    },
    {
        path: path + '/Public/RegisterAsMentor.aspx',
        name: 'RegisterAsMentor',
        component: RegisterAsMentor
    },
    {
        path: path + '/Public/FAQ.aspx',
        name: 'Faq',
        component: Faq
    },
    {
        path: path + '/Public/FAQPublic.aspx',
        name: 'FaqPublic',
        component: Faq
    },
    {
        path: path + '/',
        name: 'LandingPage2',
        component: LandingPage
    },
    {
        path: path + '/Views/LandingPageInternalVx.aspx',
        name: 'LandingPageInternal',
        component: LandingPageInternal
    },
    {
        path: path + '/Views/ApplicationStatusVx.aspx',
        name: 'ApplicationStatus',
        component: ApplicationStatus
    },
    {
        path: path + '/Views/MentorApplicationStatusVx.aspx',
        name: 'MentorApplicationStatus',
        component: MentorApplicationStatus
    },
    {
        path: path + '/Views/ProfileStatusVx.aspx',
        name: 'ProfileStatusVx',
        component: ProfileStatusVx
    },
    {
        path: path + '/Views/MentorProfileStatusVx.aspx',
        name: 'MentorProfileStatusVx',
        component: MentorProfileStatusVx
    },
    {
        path: path + '/Views/CommunityVx.aspx',
        name: 'CommunityVx',
        component: CommunityVx
    },
    {
        path: path + '/Views/CommunityAdminVx.aspx',
        name: 'CommunityAdminVx',
        component: CommunityVx
    },
    {
        path: path + '/Admin/ListOverviewVx.aspx',
        name: 'ListOverview',
        component: ListOverview
    },
    {
        path: path + '/Views/TopicNetworkVx.aspx',
        name: 'TopicNetworkVx',
        component: TopicNetwork
    },
    {
        path: path + '/Views/Application.aspx',
        name: 'ApplicationVx',
        component: TopicNetworkWidget,
        props: true,
    },
    {
        path: path + '/Views/DashboardAdminVx.aspx',
        name: 'DashboardAdminVx',
        component: DashboardAdminVx
    },
    {
        path: path + '/Views/ChangelogVx.aspx',
        name: 'RecentChangedTopics',
        component: RecentChangedTopics
    },
    {
        path: path + '/Views/DashboardVotingVx.aspx',
        name: 'DashboardVotingVx',
        component: DashboardVotingVx
    },
    {
        path: path + '/Views/CreateNewTopic.aspx/:statusId?',
        alias: path + '/Views/CreateNewTopic.aspx/:statusId?',
        name: 'CreateNewTopic',
        component: CreateNewTopic,
        props: true,
    },
    {
        path: path + '/�Public/ActivateNewAccount.aspx',
        alias: path + '/Public/ActivateNewAccount.aspx',
        name: 'ActivateNewAccount',
        component: ActivateNewAccount,
        props: true,
    },
    {
        path: path + '/Admin/RoundDetailVx.aspx/:rouId?',
        alias: path + '/Admin/RoundDetailVx.aspx/:rouId?',
        name: 'RoundDetail',
        component: RoundDetail,
        props: true,
    },
    {
        path: path + '/Admin/TopicTypeDetailVx.aspx/:ttyId?',
        alias: path + '/Admin/TopicTypeDetailVx.aspx/:ttyId?',
        name: 'TopicTypeDetail',
        component: TopicTypeDetail,
        props: true,
    },
    {
        path: path + '/Admin/RatingTypeGroupDetailVx.aspx/:rtgId?',
        alias: path + '/Admin/RatingTypeGroupDetailVx.aspx/:rtgId?',
        name: 'RatingTypeGroupDetail',
        component: RatingTypeGroupDetail,
        props: true,
    },
    {
        path: path + '/Admin/TopicMemberRoleDetailVx.aspx/:tmrId?',
        alias: path + '/Admin/TopicMemberRoleDetailVx.aspx/:tmrId?',
        name: 'TopicMemberRoleDetail',
        component: TopicMemberRoleDetail,
        props: true,
    },
    {
        path: path + '/Admin/ModulTypeDetailVx.aspx/:mtyId?',
        alias: path + '/Admin/ModulTypeDetailVx.aspx/:mtyId?',
        name: 'ModulTypeDetail',
        component: ModulTypeDetail,
        props: true,
    },
    {
        path: path + '/Admin/ModulTypeAttributeDetailVx.aspx/:matId?/:atrId?/:regId?',
        alias: path + '/Admin/ModulTypeAttributeDetailVx.aspx/:matId?/:atrId?:regId?',
        name: 'ModulTypeAttributeDetail',
        component: ModulTypeAttributeDetail,
        props: true,
    },
    {
        path: path + '/Admin/TermDetailVx.aspx/:terId?',
        name: 'TermDetail',
        component: TermDetail,
        props: true,
    },
    {
        path: path + '/Admin/ExpertTypeDetailVx.aspx',
        name: 'ExpertTypeDetail',
        component: ExpertTypeDetail
    },
    {
        path: path + '/Admin/ModulRegionDetailVx.aspx',
        name: 'ModulRegionDetail',
        component: ModulRegionDetail
    },
    {
        path: path + '/Views/TopicCardViewVx.aspx/:sufId?/:roId?/:pgId?',
        name: 'TopicCardView',
        component: TopicCardView,
        props: true
    },
    {
        path: path + '/Admin/PersonDetailVx.aspx',
        name: 'PersonDetail',
        component: PersonDetail
    },
    {
        path: path + '/Views/TopicCardClusterViewVx.aspx/:sufId?/:roId?/:pgId?',
        name: 'TopicCardClusterView',
        component: TopicCardClusterView,
        props: true
    },
    {
        path: path + '/Views/TopicCardRadarVx.aspx',
        name: 'TopicCardRadar',
        component: TopicCardRadar,
        props: true
    },
    {
        path: path + '/Admin/EventLogDetailVx.aspx',
        name: 'EventLogDetail',
        component: EventLogDetail
    },
    // {
    //     path: path + '/Admin/TokenUsageDashboardVx.aspx',
    //     name: 'TokenUsageDashboard',
    //     component: TokenUsageDashboard
    // },
    {
        path: path + '/Admin/DataImportVx.aspx',
        name: 'DataImport',
        component: DataImport
    },
    {
        path: path + '/Admin/ImportHistoryVx.aspx',
        name: 'ImportHistoryVx',
        component: ImportHistoryVx
    },
    {
        path: path + '/Admin/ImportHistoryVx.aspx/:ibId',
        name: 'ImportHistoryDetailVx',
        component: ImportHistoryDetailVx,
        props: true
    },
    {
        path: path + '/Admin/WorkflowDetailVx.aspx',
        name: 'WorkflowDetail',
        component: WorkflowDetail
    },
    {
        path: path + '/Admin/NotificationAdminVx.aspx',
        name: 'NotificationAdmin',

        component: NotificationAdmin
    },
    {
        path: path + '/Admin/NotificationDetailVx.aspx',
        name: 'NotificationDetail',
        component: NotificationDetail
    },
    {
        path: path + '/Admin/NotificationEventDetailVx.aspx',
        name: 'NotificationEventDetail',
        component: NotificationEventDetail
    },
    {
        path: path + '/Admin/RssFeedDetailVx.aspx/:rssId?',
        alias: path + '/Admin/RssFeed/:rssId?',
        name: 'RssFeedDetail',
        component: RssFeedDetail,
        props: true
    },
    {
        path: path + '/Admin/SuchfeldDetailVx.aspx/:litId?',
        alias: path + '/Admin/SuchfeldDetail/:litId?',
        name: 'SuchfeldDetail',
        component: SuchfeldDetail,
        props: true
    },
    {
        path: path + '/Views/TopicOverviewVx.aspx',
        name: 'TopicOverview',
        component: TopicOverview,
        props: (route) => {
            var ttyId = Number.parseInt(route.query.ttyId, 10)
            if (Number.isNaN(ttyId)) {
                ttyId = 0
            }
            var rouId = Number.parseInt(route.query.rouId, 10)
            if (Number.isNaN(rouId)) {
                rouId = 0
            }
            var crtId = Number.parseInt(route.query.crtId, 10)
            if (Number.isNaN(crtId)) {
                crtId = 0
            }
            const showProfileButton = false
            var showBookmarkFilter = Number.parseInt(route.query.b, 10) == 1 ? true : false;
            var showRoundFilter = Number.parseInt(route.query.r, 10) == 1 ? true : false;
            var showTopicFilter = Number.parseInt(route.query.m, 10) == 1 ? true : false;
            var showExpertsModeSwitch = Number.parseInt(route.query.e, 10) == 1 ? true : false;
            var showOwnerStatus = Number.parseInt(route.query.o, 10) == 1 ? true : false;
            var showStatusFilter = Number.parseInt(route.query.s, 10) == 1 ? true : false;
            return { ttyId, rouId, crtId, showBookmarkFilter, showProfileButton, showRoundFilter, showTopicFilter, showExpertsModeSwitch, showOwnerStatus, showStatusFilter }
        }
    },
    {
        path: path + '/Views/TopicOverviewReviewVx.aspx',
        name: 'TopicOverviewReviewVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Review Overview'
            const ttyId = 22
            const worId = 15
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const stgId = 12
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = false;
            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'XXXTitle', 'XXXTpcDescription', 'OwnerFirstName',
                'OwnerLastName', 'OwnerEmail', 'OwnerTelefon', 'TdgText002',
                'LitName001', 'TdgText001', 'TdgText003', 'TdgText004', 'TdgText005', 'SalCaptionEN', 'CityCol', 'StatusName', 'TopicStatusAction', 'MfgStatus', 'TopicLinkStatusAction',
                'TpcFullfillmentPercent',
                'CreatedBy', 'CreatedOn', 'AiField1', 'AiField2', 'AiField3',
                'ChangedBy', 'ChangedOn', 'StatusName', 'Assignee', 'XXXScout', 'Rank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, hiddenColumns, onlyOwnedTopics, showAddNew, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId }

        }
    },
    {
        path: path + '/Views/TopicOverviewProjectsVx.aspx',
        name: 'TopicOverviewProjectsVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Projects'
            const ttyId = 24
            const worId = 17
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 0
            const filterStgId = 15
            const filterTitle = 'Policies'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;

            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'SchaltzeitID', 'TpcDescription',
                'TdgMemo001',
                'TdgMultiSelect001',
                'TdgMultiSelect002',
                'TdgText001',
                'TdgText002',
                'title',
                'TpcBegin',
                'TpcEnd',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId, filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId, hiddenColumns }
        }
    },
    {
        path: path + '/Views/TopicOverviewProjectOutputsVx.aspx',
        name: 'TopicOverviewProjectOutputsVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Project Outputs'
            const ttyId = 7
            const worId = 31
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 0
            const filterStgId = 15
            const filterTitle = 'xxxx'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;

            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'SchaltzeitID', 'TpcDescription',
                'TdgMemo001',
                'TdgMultiSelect001',
                'TdgMultiSelect002',
                'TdgText001',
                'TdgText002',
                'title',
                'TpcBegin',
                'TpcEnd',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return {
                ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId,
                filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter,
                stgId, excludeStgId, listTitle, worId, hiddenColumns
            }
        }
    },

    {
        path: path + '/Views/TopicOverviewSatelliteMissionsVx.aspx',
        name: 'TopicOverviewSatelliteMissionsVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Satellite Missions'
            const ttyId = 10
            const worId = 34
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 0
            const filterStgId = 15
            const filterTitle = 'xxxx'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;

            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'SchaltzeitID', 'TpcDescription',
                'TdgMemo001',
                'TdgMultiSelect001',
                'TdgMultiSelect002',
                'TdgText001',
                'TdgText002',
                'title',
                'TpcBegin',
                'TpcEnd',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId, filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId, hiddenColumns }
        }
    },

    {
        path: path + '/Views/TopicOverviewStakeholderGroupsVx.aspx',
        name: 'TopicOverviewStakeholderGroupsVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Stakeholder Groups'
            const ttyId = 9
            const worId = 33
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 0
            const filterStgId = 15
            const filterTitle = 'xxxx'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;

            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'SchaltzeitID', 'TpcDescription',
                'TdgMemo001',
                'TdgMultiSelect001',
                'TdgMultiSelect002',
                'TdgText001',
                'TdgText002',
                'title',
                'TpcBegin',
                'TpcEnd',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId, filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId, hiddenColumns }
        }
    },

    {
        path: path + '/Views/TopicOverviewStakeholderRequirmentsVx.aspx',
        name: 'TopicOverviewStakeholderRequirmentsVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Stakeholder Requirements'
            const ttyId = 8
            const worId = 32
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 0
            const filterStgId = 15
            const filterTitle = 'xxxx'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;

            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'SchaltzeitID', 'TpcDescription',
                'TdgMemo001',
                'TdgMultiSelect001',
                'TdgMultiSelect002',
                'TdgText001',
                'TdgText002',
                'title',
                'TpcBegin',
                'TpcEnd',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId, filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId, hiddenColumns }
        }
    },


    
//import TopicOverviewProjectOutputsVx from '../views/TopicOverviewProjectOutputsVx.vue'
//import TopicOverviewSatelliteMissionsVx from '../views/TopicOverviewSatelliteMissionsVx.vue'
//import TopicOverviewStakeholderGroupsVx from '../views/TopicOverviewStakeholderGroupsVx'
//import TopicOverviewProjectOutputs from '../views/TopicOverviewStakeholderRequirmentsVx.vue'


    {
        path: path + '/Views/TopicOverviewPoliciesVx.aspx',
        name: 'TopicOverviewPoliciesVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Policies'
            const ttyId = 15
            const worId = 21
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const filterTtyId = 0
            const filterOnlyMy = false
            const filterTltId = 5
            const filterStgId = 15
            const filterTitle = 'Participants'
            const useFullTextSearch = false;
            const onlyPublishedInFilter = false
            const stgId = 0
            const excludeStgId = 0
            const rouId = 0
            const showProfileButton = true;
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;
            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'Title', 'TpcDescription',
                'TdgLisId001',
                'TdgText001',
                'TdgLisId002',
                'TdgMultiSelect002',
                'TdgText002',
                'TdgMultiSelect001',
                'TdgLisId003',
                'StatusName', 'TopicStatusAction', 'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'StatusName', 'XXXAssignee', 'XXXScout', 'xxxRank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, filterOnlyMy, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, filterStgId, filterTltId, filterTtyId, filterTitle, useFullTextSearch, onlyPublishedInFilter, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId, hiddenColumns }
        }
    },
    {
        path: path + '/Views/TopicOverviewStakeholdersVx.aspx',
        name: 'TopicOverviewStakeholdersVx',
        component: TopicOverview,
        props: () => {
            const listTitle = 'Stakeholders'
            const ttyId = 16
            const worId = 20
            const statusId = 0;
            const onlyAssignedTopics = false;
            const onlyOwnedTopics = false;
            const rouId = 0
            const stgId = 0
            const excludeStgId = 0
            const showProfileButton = false
            const showBookmarkFilter = false;
            const showRoundFilter = false;
            const showExpertsModeSwitch = false;
            const showOwnerStatus = false;
            const showStatusFilter = false;
            const showAddNew = true;
            const columns = ['actionColumn', 'commentColumn', 'flagColumn',
                'TopicId', 'Title', 'TpcDescription',
                'TdgText002',
                'TdgText003',
                'TdgText004',
                'TdgLisId001',
                'TdgLisId002',
                'CreatedBy', 'CreatedOn', 'ChangedBy', 'ChangedOn', 'TopicStatusAction', 'StatusName', 'XXXAssignee', 'XXXScout', 'Rank'];
            const columnsConfig = [
                { id: "TpcBegin", dataType: 'datetime' },
                { id: "TpcEnd", dataType: 'datetime' },
                { id: "TpcVisibleBegin", dataType: 'datetime' },
                { id: "TdgMultiSelect001", cellTemplate: 'multi' },
                { id: "TdgMultiSelect002", cellTemplate: 'multi' }
            ];
            const hiddenColumns = [];
            return { ttyId, rouId, columnsConfig, hiddenColumns, statusId, showBookmarkFilter, showProfileButton, onlyAssignedTopics, onlyOwnedTopics, showAddNew, showRoundFilter, showExpertsModeSwitch, showOwnerStatus, columns, showStatusFilter, stgId, excludeStgId, listTitle, worId }
        }
    },
    {
        path: path + '/Views/VotingOverviewVx.aspx',
        alias: path + '/Views/VotingOverviewVx.aspx',
        name: 'VotingOverview',
        component: VotingOverview
    },
    {
        path: path + '/Admin/TagDetailVx.aspx',
        name: 'TagDetail',
        component: TagDetail
    },
    {
        path: path + '/Admin/ThemeSwitcherVx.aspx',
        name: 'ThemeSwitcher',
        component: ThemeSwitcher
    },
    {
        path: path + '/Admin/IdeaApplicationSubmited.aspx',
        name: 'IdeaApplicationSubmited',
        //component: IdeaApplicationSubmited
    },
    {
        path: path + '/Views/RssFeedBrowser.aspx/:litId?/:rouId?',
        name: 'FeedBrowser',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: FeedBrowser,
        props: true
    },
    {
        path: path + '/Views/MfgSelection.aspx',
        name: 'MfgSelection',
        component: MfgSelection
    },
    {
        path: path + '/Views/MfgSelectionParticipant.aspx',
        name: 'MfgSelectionParticipant',
        component: MfgSelection
    },
    {
        path: path + '/Views/PolicyCards.aspx',
        name: 'PolicyCards',
        component: PolicyCards
    },
    {
        path: path + '/Views/StakeholderCards.aspx',
        name: 'StakeholderCards',
        component: StakeholderCards
    },
    {
        path: path + '/Views/ProjectCards.aspx',
        name: 'ProjectsCards',
        component: ProjectsCards
    },
    {
        path: path + '/Views/NewsSelectionParticipant.aspx',
        name: 'NewsSelectionParticipant',
        component: StakeholderCards
    },
    {
        path: path + '/Views/EventSelectionParticipant.aspx',
        name: 'EventSelectionParticipant',
        component: PolicyCards
    },

    {
        path: path + '/Views/StakeholderCards.aspx',
        name: 'StakeholderCards',
        component: StakeholderCards
    },
    {
        path: path + '/Views/StakeholderGroupsCards.aspx',
        name: 'StakeholderGroupsCards',
        component: StakeholderGroupsCards
    },
    {
        path: path + '/Views/ProjectOutputCards.aspx',
        name: 'ProjectOutputCards',
        component: ProjectOutputCards
    },
    {
        path: path + '/Views/SatelliteMissionsCards.aspx',
        name: 'SatelliteMissionsCards',
        component: SatelliteMissionsCards
    },
    {
        path: path + '/Views/StakeholderRequirmentsCards.aspx',
        name: 'StakeholderRequirmentsCards',
        component: StakeholderRequirmentsCards
    },

    {
        path: path + '/Views/MfgSelectionMentor.aspx',
        name: 'MfgSelectionMentor',
        component: MfgSelection,
        props: () => {
            return {
                mode: "Mentor"
            }
        }
    },
    {
        path: path + '/Views/RssFeedBrowserIntro.aspx',
        alias: path + '/Views/RssFeedBrowserIntro',
        name: 'RssFeedBrowserIntro',
        component: RssFeedBrowserIntro,
        props: (route) => {
            const userId = Number.parseInt(route.params.userId, 10)
            if (Number.isNaN(userId)) {
                return 0
            }
            return { userId }
        }
    },
    {
        path: path + '/Views/ProjectDetail.aspx/:topicId?',
        name: 'ProjectDetailVx',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Project Detail',
                readOnly: false,
                showStatusInfo: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/PolicyDetail.aspx/:topicId?',
        name: 'PolicyDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Policy',
                readOnly: false,
                showStatusInfo: true,
                showGrids: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/SatelliteMissionsDetail.aspx/:topicId?',
        name: 'SatelliteMissionsDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Satellite Missions',
                readOnly: false,
                showStatusInfo: true,
                showGrids: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/StakeholderRequirmentsDetail.aspx/:topicId?',
        name: 'StakeholderRequirmentsDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Stakeholder Requirements',
                readOnly: false,
                showStatusInfo: true,
                showGrids: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/StakeholderGroupDetail.aspx/:topicId?',
        name: 'StakeholderGroupDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Stakeholder Groups',
                readOnly: false,
                showStatusInfo: true,
                showGrids: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/ProjectOutputDetail.aspx/:topicId?',
        name: 'ProjectOutputDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Projec tOutput',
                readOnly: false,
                showStatusInfo: true,
                showGrids: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/StakeholderDetail.aspx/:topicId?',
        name: 'StakeholderDetail',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Stakeholder',
                readOnly: false,
                showStatusInfo: true,
                showAdminInfos: true,
                showLinkList: true,
                showStatusActions: true,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false
            }
        }
    },
    {
        path: path + '/Views/TopicComment.aspx/:topicId?',
        alias: path + '/Views/TopicComment/:topicId?',
        name: 'TopicComment',
        component: TopicComment,
        props: true
    },
    {
        path: path + '/Public/ResetAccount.aspx/:rc?',
        alias: path + '/Public/ResetAccount/:rc?',
        name: 'ResetAccount',
        component: ResetAccount,
        props: true
    },
    {
        path: path + '/Views/PublicProfileVx.aspx/:topicId?',
        alias: path + '/Views/TopicEntry/:topicId?',
        name: 'PublicProfile',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Profile',
                readOnly: true,
                showLinkList: true,
                showStatusInfo: false,
                showAdminInfos: false,
                showStatusActions: false,
                showLinkStatusActions: true,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Views/PublicView.aspx',
        alias: path + '/Views/TopicEntry',
        name: 'PublicView',
        component: TopicEntry,
        props: () => {
            return {
                title: 'Topics',
                readOnly: true,
                showLinkList: true,
                showStatusInfo: false,
                showAdminInfos: false,
                showStatusActions: false,
                showLinkStatusActions: false,
                showNetworkList: false,
                showOwner: false,
                showAmbassador: false
            }
        }
    },
    {
        path: path + '/Admin/PresentationGroupDetailVx.aspx/:pgrId?',
        name: 'PresentationGroupDetail',
        component: PresentationGroupDetail,
        props: true
    },
    {
        path: path + '/Public/ActivateAccount.aspx',
        name: 'ActivateAccount',
        component: ActivateAccount,
        props: route => ({ rc: route.query.rc })
    },
    {
        path: path + '/Public/ResetPassword.aspx',
        name: 'ResetPassword',
        component: ResetPassword
    },
    {
        path: path + '/Admin/NotificationAdmin.aspx',
        name: 'EmailSettings',
        component: EmailSettings
    },
    {
        path: path + '/Public/EmailConfirmation.aspx/:pgrId?',
        name: 'EmailConfirmation',
        component: EmailConfirmation,
        props: true
    }
]

//if (process.env.BASE_URL.endsWith("/")) {
//    process.env.BASE_URL = path.substring(0, path.length - 1);
//}
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    //base: 'localhost:55855X',
    //assetsPublicPath: "localhost:55855A",
    //assetsSubDirectory: "localhost:55855B",
    routes,
    scrollBehavior() {
        return { left: 0, top: 0 };
    }
})

export default router
